import { spacing1x, spacing4x, spacing6x } from "@airhelp/design-tokens";
const baseStyle = {
    root: {
        display: "flex",
        overflowX: "auto",
        msOverflowStyle: "none",
        scrollbarWidth: "none",
        "::-webkit-scrollbar": {
            display: "none",
        },
        paddingX: { base: `${spacing4x}`, lg: 0 },
        width: { base: "100vw", lg: "100%" },
        marginLeft: { base: `-${spacing4x}`, lg: 0 },
    },
    tablist: {
        color: "greyscale.600",
        flexBasis: "100%",
    },
    tab: {
        padding: `0 ${spacing6x} ${spacing1x} !important`,
        margin: "2px 0px",
        whiteSpace: "nowrap",
        _selected: {
            color: "primary.900",
            borderBottomColor: "primary.500 !important",
            fontWeight: "medium",
            backgroundColor: "transparent",
        },
        _hover: { color: "greyscale.600", borderBottomColor: "primary.300" },
    },
};
const Tabs = { baseStyle };
export default Tabs;
